import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AppConstants } from '../../../core/common/app-constants';


@Component({
selector: 'app-footer',
standalone: true,
templateUrl: './footer.component.html',
styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  private router = inject(Router);
  year = new Date().getFullYear();

  FE(){
    this.router.navigate([AppConstants.routes.SYSTEM_FACTURACION]);
  }
  VO(){
    this.router.navigate([AppConstants.routes.SYSTEM_VENTASONLINE]);
  }
  WE(){
    this.router.navigate([AppConstants.routes.SYSTEM_ENCUENTRAME]);
  }

  Contacto(){
    this.router.navigate([AppConstants.routes.CONTACT]);
  }
}